import { eventTypeLabel } from "constants/eventTypeLabels";

/**
 * Display labels for the artist_type field returned by /admin/services serializers.
 * Keys mirror the values the enrichment layer can produce.
 */
export const ARTIST_TYPE_LABELS = {
    dj: "DJ",
    musician: "Musicien",
    user_artist_dj: "DJ",
    user_artist_musician: "Musicien",
    artist_group_musician: "Groupe musicien",
    artist_group_dj: "Groupe DJ",
};

/**
 * Builds a short label combining events and thematics arrays into a single string,
 * truncated to keep the table compact. Falls back to the country or "Service" placeholder.
 * @param {Object} service - Service object
 * @returns {string}
 */
export function formatServiceLabel(service) {
    const events = (Array.isArray(service?.events) ? service.events.filter(Boolean) : [])
        .filter((event) => event !== "all_events")
        .map(eventTypeLabel);
    const themes = Array.isArray(service?.thematics) ? service.thematics.filter(Boolean) : [];
    const joined = [...events, ...themes].slice(0, 3).join(" · ");
    if (joined) return joined;
    return service?.country || "Service";
}

/**
 * Formats a price + assumed currency. The /admin/services serializer does not include
 * a currency code, so we only render the bare numeric value here. Frontend admins can
 * cross-reference the artist profile if needed.
 * @param {number|null|undefined} price - Service price
 * @returns {string}
 */
export function formatServicePrice(price) {
    if (price === null || price === undefined) return "—";
    return Number(price).toFixed(2);
}

/** Number of services returned by both /last and /search (hardcoded server-side). */
export const SERVICES_PAGE_SIZE = 10;

/** Search debounce delay (ms). */
export const SEARCH_DEBOUNCE_MS = 300;
